import styled from 'styled-components';
import Menu from '@material-ui/core/Menu';
import MaterialUIMenuItem from '@material-ui/core/MenuItem';

export const MenuItem = styled(MaterialUIMenuItem)`
  &:not(:last-child) {
    border-bottom: 1px solid ${props => props.theme.colors.border.default};
  }
`;

export default styled(Menu)`
  & .MuiPaper-rounded {
    border-radius: ${props => props.theme.borderRadius.medium};
  }
`;
